function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1968(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20.74,
    height: 9.84,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7569230769230769
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 4.92
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.84,
    width: 20.74,
    height: 12.13,
    style: {
      fill: "#006600"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.021666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 15.905000000000001
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.97,
    width: 20.74,
    height: 13.47,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9242857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 28.705
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.45,
    width: 20.74,
    height: 14.11,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0157142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 42.505
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.56,
    width: 20.74,
    height: 18.23,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.27875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 58.675000000000004
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 67.79,
    width: 20.74,
    height: 20.63,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.438333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 78.105
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.43,
    width: 20.74,
    height: 23.77,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 100.31500000000001
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 112.19,
    width: 20.74,
    height: 24.22,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 124.3
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 136.42,
    width: 20.74,
    height: 26.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.074
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 149.815
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 163.21,
    width: 20.74,
    height: 28.63,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 177.525
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 191.83,
    width: 20.74,
    height: 29.14,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 206.4
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 220.97,
    width: 20.74,
    height: 30.23,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 236.085
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 251.2,
    width: 20.74,
    height: 30.63,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 266.515
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 281.83,
    width: 20.74,
    height: 31.25,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9628571428571426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 297.455
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 313.08,
    width: 20.74,
    height: 31.61,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9628571428571426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 328.885
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 344.69,
    width: 20.74,
    height: 32.39,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.148
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 360.885
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 377.08,
    width: 20.74,
    height: 33.16,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 393.65999999999997
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 410.24,
    width: 20.74,
    height: 33.39,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 426.935
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 443.62,
    width: 20.74,
    height: 33.63,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 460.435
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 477.25,
    width: 20.74,
    height: 34.24,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.148
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 494.37
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 511.49,
    width: 20.74,
    height: 35.82,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 529.4
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 547.31,
    width: 20.74,
    height: 36.09,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9628571428571426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 565.3549999999999
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 583.4,
    width: 20.74,
    height: 36.73,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 601.765
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 620.13,
    width: 20.74,
    height: 39.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 639.96
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 659.79,
    width: 20.74,
    height: 40.21,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.148
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.37,
    y: 679.895
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 0,
    width: 26.96,
    height: 30.98,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8514285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.22,
    y: 15.49
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 0,
    width: 27.69,
    height: 30.98,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.955714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.545,
    y: 15.49
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.39,
    y: 0,
    width: 28.05,
    height: 30.98,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 89.415,
    y: 15.49
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.44,
    y: 0,
    width: 28.63,
    height: 30.98,
    style: {
      fill: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.57875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.755,
    y: 15.49
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.06,
    y: 0,
    width: 28.64,
    height: 30.98,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.546666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.38,
    y: 15.49
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 0,
    width: 28.87,
    height: 30.98,
    style: {
      fill: "#006600"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8116666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.135,
    y: 15.49
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.57,
    y: 0,
    width: 28.94,
    height: 30.98,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.894
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.04,
    y: 15.49
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.51,
    y: 0,
    width: 29.28,
    height: 30.98,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.14999999999998,
    y: 15.49
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.8,
    y: 0,
    width: 29.79,
    height: 30.98,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.958
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.695,
    y: 15.49
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.59,
    y: 0,
    width: 29.97,
    height: 30.98,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.994
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.575,
    y: 15.49
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.56,
    y: 0,
    width: 30.6,
    height: 30.98,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.86,
    y: 15.49
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.16,
    y: 0,
    width: 31.54,
    height: 30.98,
    style: {
      fill: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.93,
    y: 15.49
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.69,
    y: 0,
    width: 31.75,
    height: 30.98,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.196
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.565,
    y: 15.49
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.45,
    y: 0,
    width: 31.97,
    height: 30.98,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.425714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.435,
    y: 15.49
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.41,
    y: 0,
    width: 31.98,
    height: 30.98,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.40000000000003,
    y: 15.49
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.39,
    y: 0,
    width: 32.03,
    height: 30.98,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.163333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.405,
    y: 15.49
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.42,
    y: 0,
    width: 32.93,
    height: 30.98,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.098
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.885,
    y: 15.49
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.35,
    y: 0,
    width: 33.75,
    height: 30.98,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.163333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.225,
    y: 15.49
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.1,
    y: 0,
    width: 33.85,
    height: 30.98,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.163333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.025,
    y: 15.49
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.95,
    y: 0,
    width: 33.88,
    height: 30.98,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.425714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.8900000000001,
    y: 15.49
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.83,
    y: 0,
    width: 33.89,
    height: 30.98,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.196
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.7750000000001,
    y: 15.49
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 665.72,
    y: 0,
    width: 34.28,
    height: 30.98,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.163333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 682.86,
    y: 15.49
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 30.98,
    width: 33.63,
    height: 31.96,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.326666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 46.96
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 62.94,
    width: 33.63,
    height: 32.2,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 79.03999999999999
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 95.14,
    width: 33.63,
    height: 32.63,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.526000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 111.455
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 127.77,
    width: 33.63,
    height: 32.69,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.537999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 144.115
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 160.46,
    width: 33.63,
    height: 33.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.644
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 177.07
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 193.68,
    width: 33.63,
    height: 33.33,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6659999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 210.345
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 227,
    width: 33.63,
    height: 33.42,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.774285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 243.71
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 260.42,
    width: 33.63,
    height: 33.92,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3630000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 277.38
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 294.34,
    width: 33.63,
    height: 34.59,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.20375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 311.635
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 328.93,
    width: 33.63,
    height: 34.73,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 346.295
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 363.66,
    width: 33.63,
    height: 35.34,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.726000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 381.33000000000004
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 399,
    width: 33.63,
    height: 36.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.726000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 417.07
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 435.13,
    width: 33.63,
    height: 36.25,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.726000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 453.255
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 471.38,
    width: 33.63,
    height: 36.54,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.726000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 489.65
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 507.93,
    width: 33.63,
    height: 37.52,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 526.69
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 545.45,
    width: 33.63,
    height: 37.64,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 564.2700000000001
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 583.09,
    width: 33.63,
    height: 38.54,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.804285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 602.36
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 621.62,
    width: 33.63,
    height: 39.09,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.4075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 641.165
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.74,
    y: 660.72,
    width: 33.63,
    height: 39.28,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.20375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.555,
    y: 680.36
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 30.98,
    width: 34.9,
    height: 38,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8777777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.83,
    y: 49.980000000000004
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.28,
    y: 30.98,
    width: 36.2,
    height: 38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.033333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.38,
    y: 49.980000000000004
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.48,
    y: 30.98,
    width: 36.4,
    height: 38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.68,
    y: 49.980000000000004
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.87,
    y: 30.98,
    width: 36.46,
    height: 38,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.076666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.1,
    y: 49.980000000000004
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.33,
    y: 30.98,
    width: 36.76,
    height: 38,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.71,
    y: 49.980000000000004
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.09,
    y: 30.98,
    width: 36.8,
    height: 38,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.359999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.49,
    y: 49.980000000000004
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.88,
    y: 30.98,
    width: 37.24,
    height: 38,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.5,
    y: 49.980000000000004
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.12,
    y: 30.98,
    width: 37.32,
    height: 38,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.331428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.78000000000003,
    y: 49.980000000000004
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.45,
    y: 30.98,
    width: 37.64,
    height: 38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.377142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.27,
    y: 49.980000000000004
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.09,
    y: 30.98,
    width: 38.45,
    height: 38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.428571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.315,
    y: 49.980000000000004
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.54,
    y: 30.98,
    width: 38.69,
    height: 38,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.428571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.885,
    y: 49.980000000000004
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.23,
    y: 30.98,
    width: 38.98,
    height: 38,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.333333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.72,
    y: 49.980000000000004
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.21,
    y: 30.98,
    width: 39.48,
    height: 38,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.428571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.9499999999999,
    y: 49.980000000000004
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.69,
    y: 30.98,
    width: 39.67,
    height: 38,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.333333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.5250000000001,
    y: 49.980000000000004
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.35,
    y: 30.98,
    width: 40.07,
    height: 38,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.333333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.385,
    y: 49.980000000000004
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.42,
    y: 30.98,
    width: 40.26,
    height: 38,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.55,
    y: 49.980000000000004
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.69,
    y: 30.98,
    width: 40.31,
    height: 38,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.845,
    y: 49.980000000000004
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 68.98,
    width: 40.58,
    height: 38.09,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.348333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 88.025
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 107.07,
    width: 40.58,
    height: 38.29,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.254444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 126.21499999999999
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 145.36,
    width: 40.58,
    height: 38.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 164.78500000000003
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 184.21,
    width: 40.58,
    height: 38.87,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.85875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 203.645
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 223.08,
    width: 40.58,
    height: 40.14,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.734285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 243.15
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 263.22,
    width: 40.58,
    height: 40.3,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 283.37
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 303.52,
    width: 40.58,
    height: 40.88,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.797142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 323.96
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 344.4,
    width: 40.58,
    height: 41.14,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.797142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 364.96999999999997
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 385.54,
    width: 40.58,
    height: 42.22,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.116
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 406.65000000000003
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 427.76,
    width: 40.58,
    height: 42.81,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.797142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 449.16499999999996
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 470.57,
    width: 40.58,
    height: 44.64,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 492.89
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 515.21,
    width: 40.58,
    height: 45.57,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.058
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 537.995
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 560.78,
    width: 40.58,
    height: 45.85,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 583.7049999999999
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 606.64,
    width: 40.58,
    height: 46.1,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 629.6899999999999
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 652.74,
    width: 40.58,
    height: 47.26,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.116
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.67,
    y: 676.37
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 68.98,
    width: 43.87,
    height: 45.15,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.48375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.895,
    y: 91.555
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.83,
    y: 68.98,
    width: 44.55,
    height: 45.15,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.56875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.10500000000002,
    y: 91.555
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.38,
    y: 68.98,
    width: 44.9,
    height: 45.15,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.82999999999998,
    y: 91.555
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.29,
    y: 68.98,
    width: 45.26,
    height: 45.15,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.92,
    y: 91.555
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.55,
    y: 68.98,
    width: 45.3,
    height: 45.15,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.016666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.2,
    y: 91.555
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.84,
    y: 68.98,
    width: 45.34,
    height: 45.15,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.03
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.51,
    y: 91.555
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.18,
    y: 68.98,
    width: 46.58,
    height: 45.15,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.016666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.47,
    y: 91.555
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.76,
    y: 68.98,
    width: 46.72,
    height: 45.15,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5249999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.12,
    y: 91.555
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.48,
    y: 68.98,
    width: 47.32,
    height: 45.15,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.14000000000004,
    y: 91.555
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.8,
    y: 68.98,
    width: 47.51,
    height: 45.15,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 528.5550000000001,
    y: 91.555
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.31,
    y: 68.98,
    width: 48.91,
    height: 45.15,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.765,
    y: 91.555
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.21,
    y: 68.98,
    width: 49.38,
    height: 45.15,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.016666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 625.9000000000001,
    y: 91.555
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.6,
    y: 68.98,
    width: 49.4,
    height: 45.15,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.03
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.3000000000001,
    y: 91.555
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 114.13,
    width: 49.78,
    height: 44.86,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.476666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 136.56
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 158.99,
    width: 49.78,
    height: 44.99,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.998000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 181.485
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 203.98,
    width: 49.78,
    height: 45.68,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 226.82
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 249.66,
    width: 49.78,
    height: 46.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 272.85
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 296.05,
    width: 49.78,
    height: 47.65,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.941666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 319.875
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 343.7,
    width: 49.78,
    height: 48.12,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.874285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 367.76
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 391.81,
    width: 49.78,
    height: 48.41,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9157142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 416.015
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 440.22,
    width: 49.78,
    height: 50.04,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 465.24
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 490.26,
    width: 49.78,
    height: 51.75,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 516.135
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 542.01,
    width: 49.78,
    height: 51.75,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.956
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 567.885
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 593.75,
    width: 49.78,
    height: 52.55,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 620.025
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.96,
    y: 646.3,
    width: 49.78,
    height: 53.7,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.85,
    y: 673.15
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 114.13,
    width: 51.58,
    height: 53.17,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.596666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 170.53,
    y: 140.715
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.33,
    y: 114.13,
    width: 51.99,
    height: 53.17,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.427142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.32500000000002,
    y: 140.715
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.32,
    y: 114.13,
    width: 52.42,
    height: 53.17,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.488571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.53,
    y: 140.715
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.74,
    y: 114.13,
    width: 53.43,
    height: 53.17,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.595714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.455,
    y: 140.715
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.17,
    y: 114.13,
    width: 54.82,
    height: 53.17,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.861666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.58000000000004,
    y: 140.715
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.99,
    y: 114.13,
    width: 55,
    height: 53.17,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.64625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.49,
    y: 140.715
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.99,
    y: 114.13,
    width: 57.89,
    height: 53.17,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.595714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.935,
    y: 140.715
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.88,
    y: 114.13,
    width: 58.51,
    height: 53.17,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.634
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.135,
    y: 140.715
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.39,
    y: 114.13,
    width: 58.79,
    height: 53.17,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.785,
    y: 140.715
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.18,
    y: 114.13,
    width: 60.82,
    height: 53.17,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.861666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.5899999999999,
    y: 140.715
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 167.3,
    width: 62.1,
    height: 58.85,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.79000000000002,
    y: 196.72500000000002
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 226.15,
    width: 62.1,
    height: 59.28,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.468571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.79000000000002,
    y: 255.79000000000002
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 285.43,
    width: 62.1,
    height: 62.38,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.79000000000002,
    y: 316.62
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 347.81,
    width: 62.1,
    height: 64.35,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.79000000000002,
    y: 379.985
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 412.16,
    width: 62.1,
    height: 69.29,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.79000000000002,
    y: 446.805
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 481.45,
    width: 62.1,
    height: 70.39,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.871428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.79000000000002,
    y: 516.645
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 551.84,
    width: 62.1,
    height: 72.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.79000000000002,
    y: 588.1500000000001
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 624.46,
    width: 62.1,
    height: 75.54,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.871428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.79000000000002,
    y: 662.23
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.85,
    y: 167.3,
    width: 64.11,
    height: 75.3,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.822
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.905,
    y: 204.95000000000002
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.95,
    y: 167.3,
    width: 64.37,
    height: 75.3,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.874
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.135,
    y: 204.95000000000002
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.32,
    y: 167.3,
    width: 66.82,
    height: 75.3,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.545714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.73,
    y: 204.95000000000002
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.14,
    y: 167.3,
    width: 71.01,
    height: 75.3,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.7525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.645,
    y: 204.95000000000002
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.15,
    y: 167.3,
    width: 74.54,
    height: 75.3,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.423333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.41999999999996,
    y: 204.95000000000002
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.68,
    y: 167.3,
    width: 75.24,
    height: 75.3,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.748571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.3,
    y: 204.95000000000002
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 622.93,
    y: 167.3,
    width: 77.07,
    height: 75.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.549999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.4649999999999,
    y: 204.95000000000002
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.85,
    y: 242.6,
    width: 99.21,
    height: 69.09,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.63625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.455,
    y: 277.145
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.85,
    y: 311.69,
    width: 99.21,
    height: 74.11,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.234444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.455,
    y: 348.745
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.85,
    y: 385.8,
    width: 99.21,
    height: 84.98,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.996000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.455,
    y: 428.29
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.85,
    y: 470.78,
    width: 99.21,
    height: 92.58,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.225714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.455,
    y: 517.0699999999999
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.85,
    y: 563.36,
    width: 99.21,
    height: 136.64,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.40125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.455,
    y: 631.6800000000001
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.06,
    y: 242.6,
    width: 116.35,
    height: 122.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.54375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.235,
    y: 303.74
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.41,
    y: 242.6,
    width: 132.68,
    height: 122.28,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.75,
    y: 303.74
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.1,
    y: 242.6,
    width: 144.9,
    height: 122.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.5500000000001,
    y: 303.74
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.06,
    y: 364.88,
    width: 184.52,
    height: 113.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.247142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 398.32,
    y: 421.745
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.06,
    y: 478.61,
    width: 184.52,
    height: 221.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.753333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 398.32,
    y: 589.3050000000001
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.58,
    y: 364.88,
    width: 209.42,
    height: 335.12,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.90333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.29,
    y: 532.44
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1968);
export default __webpack_public_path__ + "static/media/1968.a3d1dfa88eda1d365895d6446f7c04b2.svg";
export { ForwardRef as ReactComponent };